<template>
  <DialogTemplateToolkit
    v-if="showAction"
    :dialog="dialog"
    first_btn="Purchasing.Remove"
    :loading="loading"
    :title="modalTitle"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <MenuItem
        v-if="list"
        class="h11-links"
        data-qa="item-delete"
        icon="delete"
        :label="$t('Tenders.DeleteTender')"
        @click="open"/>
      <sButton
        v-else
        color="var(--white-color)"
        data-qa="btn-delete"
        icon="delete"
        type="text"
        @click="open">
        {{ $t('Tenders.DeleteTender') }}
      </sButton>
    </template>
    <template #card-text>
      <template v-if="tenderIsPlaningAndMailSending">
        <sFormItem
          ref="reason"
          prop="reason"
          :rules="reasonRules">
          <template #label>
            <span class="text-capitalize">
              {{ $t('Suppliers.Comment') }}
            </span>
          </template>
          <sInput
            clearable
            data-qa="delete-reason"
            :max-length="4000"
            max-rows="20"
            rows="6"
            show-word-limit
            type="textarea"
            :value.sync="reason"/>
        </sFormItem>
        <sAlert class="mt-5">
          {{ $t('Tenders.DeletePlaningTenderText') }}
        </sAlert>
      </template>
      <v-card-title
        v-else
        class=" h2-headline-medium pa-0 pb-5">
        {{ $t('Tenders.SureDeleteTender',
              {item: `#${tender.tenderNumber} ${tender.tenderSubject || tender.title}` } ) }}
      </v-card-title>
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const st_api = new SmarttenderApi()

export default {
  name: 'deleteTender',
  data() {
    const that = this
    return {
      dialog: false,
      reason: null,
      loading: false,
      reasonRules: [{
        required: true,
        trigger: 'change',
        transform(value) {
          return value?.trim()
        },
        validator(rule, value, callback) {
          if (!that.reason) {
            callback(new Error(that.$t('Validate.Required')))
          }

          callback()
        },
      },
      {
        type: 'string',
        trigger: 'change',
        transform() {
          return that.reason?.trim()
        },
        max: 4000,
        message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
      }
      ]
    }
  },
  props: {
    tender: Object,
    list: Boolean,
    all_tenders: Array,
    show: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    open() {
      setTimeout(() => {
        this.dialog = true
      }, 100)
    },
    close() {
      this.reason = null
      this.dialog = false
    },
    apply() {
      this.loading = true
      if (this.tenderIsPlaningAndMailSending) {
        this.validateAndDelete()
      } else {
        this.deleteTender()
      }
    },
    validateAndDelete() {
      this.$refs.reason.validateAsync().then(result => {
        if (result.valid) {
          this.deleteTender()
        } else {
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    deleteTender() {
      st_api.deleteTender(this.tender.tenderId, this.reason)
        .then(res => {
          if (!res) {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Tenders.ErrorDeleteTender'), //todo текстовка
              duration: 10,
            })
            this.close()
            return
          }
          let tendersCount = this.$store.getters['getTendersCount'] - 1,
            tenders =  this.$store.getters['getTenders']?.filter(item => item.tenderId != this.tender.tenderId)

          this.$store.commit('setTenders', tenders)
          this.$store.commit('setTendersCount',  tendersCount)
          this.$root.$emit('loadData', {update_count: true})

          this.close()
          this.$emit('callback')
        })
        .catch(error => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Tenders.ErrorDeleteTender'), //todo текстовка
            duration: 10,
          })
          this.close()
          this.$log_error(error.message)
        }).finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    tenderIsPlaningAndMailSending() {
      return this.tender?.tenderPublishedSchedule?.scheduledDate && this.tender?.tenderPublishedSchedule?.isScheduled && this.tender?.tenderPublishedSchedule?.previousMailing
    },
    modalTitle() {
      return this.tenderIsPlaningAndMailSending ? `${this.$t('Tenders.DeletePlaningTender')} #${this.tender.tenderNumber}` : this.$t('Tenders.DeleteTender')
    },
    showAction() {
      if (!this.show) {
        return false
      }
      return (this.tender.tenderStatus?.id == 1 || this.tender.tenderStatusId == 1) && !this.tender.publishedDate
    },
  },
  components: {
    MenuItem,
    DialogTemplateToolkit
  }
}
</script>
